let pos_comp_surveyDoneView_en = require("./templates/pos/comp/surveyDoneView_en.handlebars");
let pos_comp_surveyDoneView = require("./templates/pos/comp/surveyDoneView.handlebars");
let BillPayView = require("./templates/cashier/BillPayView.handlebars");
let Membership_chargeView = require("./templates/pos/comp/MembershipChargeView.handlebars");

let $ = require('jquery');
let _ = require("underscore");
let Backbone = require("backbone");
import OrderView from "./view/order/OrderView.js";
import TableView from "./view/table/TableView.js";
import CashierView from "./view/cashier/CashierView.js";

import SettingsView from "./view/settings/SettingsView.js";
import OverviewView from "./view/OverviewView.js";
import i18n from "./utils/i18n";

let DB = require("./recorder/DbRecorder.js");
let HelpModalView = require("./view/HelpModalView.js");
import i18nc from "i18next";
let ActivityModalView = require("./view/ActivityModalView.js");
let ConsultModalView = require("./view/ConsultModalView.js");
let GuideView = require("./view/comp/GuideView.js");
let MobileOrderModalView = require("./view/MobileOrderModalView.js");

let PosRouter = require('./PosRouter.js');
let {LogUtil} = require('./utils/utils');
import ModalView from "./view/comp/ModalView.js";
import PurchaseLicenseService from './service/PurchaseLicenseService.js';
let PurchaseLicenseView = require('./view/comp/PurchaseLicenseView.js');
import PrintService from './service/PrintService.js';
import NotificationService from './service/NotificationService.js';
import PrinterStatusView from "./view/PrinterStatusView.js";
import NoteSelectorView from "./view/cashier/NoteSelectorView.js";
import MembershipChargeView from "./view/comp/MembershipChargeView.js";
import POS from "./POS.js";
import BillRecorder from "./recorder/BillRecorder.js";
import TooieStatusService from './service/TooieStatusService.js';
import NotificationView from './view/comp/NotificationView.js';
import TooieStatusView from './view/comp/TooieStatusView.js';

let main = function () {
    return Backbone.View.extend({
        router: null,
        overviewView: null,
        tableView: null,
        orderView: null,
        settingsView: null,
        salesView: null,
        notificationCenterView: null,
        tooieStatusView: null,
        cashierView: null,
        needRefresh: false,
        overviewKeyPageChange: null,

        events: {
            "keyup": "fastTableSearchFromKeyboard",
            'click .mainMenu span': 'highlightState',
            'click .mainMenu .activity': 'activityModal',
            'click .mainMenu .help': 'helpModal',
            'click .help-icon': 'helpModal',
            'click .mainMenu .tip': 'showWebchat',
            'click .print-status': 'showStatus',
            'click .notification-icon': 'showDetails',
            'click .sync-icon': 'syncIconClicked',
            'click .consultReserveTime': 'consultModal',
            'click .surveyActivity': 'survey',
            'click .mainMenu .dropdown-toggle': 'changeStyle',
            'click .mobile-order': "mobileOrderClicked",
            'click .nav.mainMenu > a': "mainMenuLinkClicked",
            'click .dropdown-menu > .dropdownli > a': "dropdownMenuLinkClicked",
            'click .mainMenu .pricing': "purchaseLicense",
            'click .mainMenu .flushLi': "reload",
            'click .mainMenu .memberCharge': "_charge",
        },

        fastTableSearchFromKeyboard: function (event) {
            let hash = window.location.hash;
            if (hash.contains("overview")) {
                this.overviewView.fastTableSearchFromKeyboard(event)
            } else if (hash.contains("cashier")) {
                if (this.cashierView.numberpad && !$(".membership-input").is(":focus") && !$(".type-password").is(":focus") && !$(".note").is(":focus")) {
                    var status = $(".modal-backdrop.in").css("display");
                    if (status == undefined || status == '') {
                        this.cashierView.numberpad._focusNumberInput();
                        this.cashierView.numberpad._onKeyUp(event);
                    }
                }
            }
        },

        helpModal: function (e) {

        },

        consultModal: function () {
            this.consultModalView.show();
        },

        activityModal: function () {
            this.activityModalView.show();
        },

        showDetails: function (evt) {
            this.notificationView._toggleCenter();
            return false;
        },

        showStatus: function () {
            this.printerStatusView.show();
        },

        syncIconClicked: function () {
            BillRecorder.reschedulePollSyncNow();
        },

        showWebchat: function () {
            Intercom('show');
        },
        survey: function () {
            location.assign("/survey?source=POS");
        },

        changeStyle: function (evt) {
            // HACK: see http://alittlecode.com/fix-twitter-bootstraps-dropdown-menus-in-touch-screens/
            var target = $(evt.currentTarget);
            evt.preventDefault();
            setTimeout($.proxy(function () {
                if ('ontouchstart' in document.documentElement) {
                    $(target).siblings('.dropdown-backdrop').off().remove();
                }
            }, target), 0);
            if (target.hasClass('open')) {
                target.removeClass('open');
            } else {
                target.addClass('open');
            }
        },
        initialize: function () {
            this.mobileOrderModalView = new MobileOrderModalView();
            var self = this;


            // if running in chrome, contact print plugin to check printer status and also listens to
            // error msg.
            if (typeof(chrome) !== 'undefined' && typeof(chrome.runtime) !== 'undefined') {
                this._connectToChromePlugins()
            }
            this.initPrintRecord();
            this.initPurchaseLicense();
            this.initNotificationView();
            this.initTooieStatusView();
            this.guideView = new GuideView({restStatus: this.model.get("restStatus")});
            var noteSelectorView = new NoteSelectorView({el: "#paymentNotesModal", model: POS.getRestaurant()});
            this.overviewView = new OverviewView({el: $('#overview'), guideView: this.guideView});
            this.tableView = new TableView({el: $('#table'), guideView: this.guideView});
            this.orderView = new OrderView({
                el: $('#order'),
                model: new Backbone.Model(),
                guideView: this.guideView
            });
            this.orderView.noteview = noteSelectorView;
            this.settingsView = new SettingsView({
                el: $('#settings'),
                purchaseView: self.purchaseLicenseView
            });
            this.salesView = new SettingsView({el: $('#sales')});
            this.helpModalView = new HelpModalView();
            this.consultModalView = new ConsultModalView();
            this.activityModalView = new ActivityModalView();

            this.listenTo(this.settingsView, "needRefresh", function () {
                self.needRefresh = true;
            });

            this.cashierView = new CashierView({
                el: $('#cashier'),
                guideView: this.guideView,
                model: new Backbone.Model({restaurantId: this.model.get("rId")})
            });
            this.cashierView.noteview = noteSelectorView;
            this.router = new PosRouter();
            this.router.hasBaseFeature = this.model.checkFeature("BASE");
            this.listenTo(this.router, 'changeState', this.changeState);
            this.listenTo(this.guideView, 'clickBtn', this.clickBtn);
            this.listenTo(this.guideView, 'clickImg', this.clickImg);
            this.listenTo(this.guideView, 'subscript', this.subscript);
            POS.getSyncStatus().on("change:syncing", this.syncStateChanged.bind(this));

            Backbone.history.start();

            if (!DB.read("seenHelp")) {
//                    this.helpModal();
//                    this.consultModal();
                DB.save("seenHelp", true);
            }
        },
        render: function () {
            if (!this.model.checkFeature("BASE")) {
                this.settingsView.render({type: "license"});
                this.$('.mainMenu .settings').addClass('active');
                this.$("#settings").removeClass("hidden");
            } else {
                if (window.location.hash == "") {
                    Backbone.history.navigate('overview', {trigger: true});
                }
            }

            var self = this;
            self.$el.addClass("status-online");
            var networkIcon = self.$(".functionButtons .network-icon");

            DB.getStatusModel().on('change', function () {
                this.$el.toggleClass("status-offline", !DB.getStatusModel().get('online'));
                this.$el.toggleClass("status-online", DB.getStatusModel().get('online'));
                this.$el.toggleClass("websocket-online", DB.getStatusModel().get('websocketOnline'));
                this.$el.toggleClass("websocket-offline", !DB.getStatusModel().get('websocketOnline'));
                if (!DB.getStatusModel().get('online')) {
                    // display offline tooltip
                    networkIcon.attr("title", i18nc.t('pos.network.offline'));
                    networkIcon.tooltip('show');
                } else {
                    networkIcon.tooltip('hide');
                }
            }, self);
            console.timeEnd('posview-render');
            console.log('FINISH ALL SETUP', new Date());
        },
        mobileOrderClicked: function () {
            this.mobileOrderModalView.show();
        },
        submitForm: function (email) {
            var self = this, jxhr,
                restaurant = POS.getRestaurant(),
                params = {};
            if (restaurant.get('experienceRestaurant')) {
                if (typeof email == 'undefind' || !email) {
                    alert(i18n.msg('pos.register.survey.email'));
                    return false;
                }
            }
            params.email = email;
            params.restaurantId = restaurant.get('id');
            jxhr = $.post('/marketing/registerForSendAnalytics', params);
            jxhr.done(function (response) {
                if (response.success) {
                    self.guideView.$el.find('.survey-form').hide();
                    self.guideView.$el.find('.success').removeClass('hidden');
                    if (response.user && response.user.phone) {
                        self.guideView.$el.find('.success .email').addClass('hidden');
                        self.guideView.$el.find('.success .wechat').addClass('hidden');
                    } else {
                        self.guideView.$el.find('.success .phone').addClass('hidden');
                        self.guideView.$el.find('.success .wechat').addClass('hidden');
                    }
                    self.guideView.$el.find('.send-success').removeClass('hidden');
                    if (restaurant.get('experienceRestaurant')) {
                        self.needRefresh = true;
                        self.$('.experienceRestaurantHint').hide();
                        restaurant.set('experienceRestaurant', false);
                    }
                } else {
                    self.guideView.setErrors(response.errors);
                }
                jxhr.fail(function (response) {

                });
            });
        },

        _registerExperience: function () {
            var english = $("body").hasClass('lang-nonchinese'), guiTem, self = this;
            this.guideView.model.clear({silent: true});
            if (english) {
                guiTem = $(pos_comp_surveyDoneView_en({experienceRestaurant: POS.getRestaurant().get('experienceRestaurant')}));
                self.guideView.model.set({
                    guideModal: guiTem,
                    guideFoot: "<div class='survey-form'><button class='btn btn-default next-time close-modal'>" + i18n.msg('pos.nextTime') + "</button>" +
                    "<div class='gb'><button class='btn btn-default to-sales'>" + i18n.msg('pos.survey.button.register') + "</button></div></div>" +
                    "<div class='send-success hidden'><button class='btn btn-close subscribe-done'>" + i18n.msg('pos.iknew') + "</div></button></div>"
                });
                self.listenTo(self.guideView, 'submitForm', self.submitForm);
            } else {
                var jxhr = $.post('/analytics/_qrCode', {restaurantId: POS.getRestaurant().get('id')});
                jxhr.done(function (response) {
                    var qrCode = response.qrCode;
                    var staffId = response.staff;
                    guiTem = $(pos_comp_surveyDoneView({
                        staffId: staffId,
                        qrCode: qrCode,
                        experienceRestaurant: POS.getRestaurant().get('experienceRestaurant')
                    }));
                    self.guideView.model.set({
                        guideModal: guiTem,
                        guideFoot: "<div class='survey-form'><button class='btn btn-default next-time'>" + i18n.msg('pos.nextTime') + "</button>" +
                        "<div class='gb'><button class='btn btn-default to-sales'>" + i18n.msg('pos.survey.button.register') + "</button></div></div>" +
                        "<div class='send-success hidden'><button class='btn btn-close subscribe-done'>" + i18n.msg('pos.iknew') + "</div></button></div>"
                    });
                    self.listenTo(self.guideView, 'submit', self.submitForm);
                });
                jxhr.fail(function () {

                });
            }
        },

        _toMoreFunctionGuide: function () {
            console.log(" console.log(POS.getRestaurant().get('locale'));", POS.getRestaurant().get('locale'));
            var english = $("body").hasClass('lang-nonchinese'), guiTem, self = this;
            this.guideView.model.clear({silent: true});
            if (!english) {
                guiTem = "<img class='to-membership' src=" + i18n.msg('pos.introduce.more3.image') + ">" +
                    "<img class='to-analytics' src=" + i18n.msg('pos.introduce.more2.image') + ">" +
                    "<img class='to-wechat' src=" + i18n.msg('pos.introduce.more1.image') + ">";

                self.guideView.model.set({
                    guideImage: guiTem,
                    guideText: "<span><img src='/images/pos/point.png'><img src='/images/pos/point.png'><img src='/images/pos/point.png'>" + i18n.msg('pos.introduce') +
                    "<img src='/images/pos/point.png'><img src='/images/pos/point.png'><img src='/images/pos/point.png'></span>",
                    guideBtn: "<button class='btn btn-default close-modal next-time'>" + i18n.msg('pos.nextTime') + "</button>"
                });
                self.guideView.$el.addClass('more-function');
            }
        },

        clickImg: function (params) {
            var img = params.img;
            if (img.hasClass('to-membership')) {
                window.location.href = '#settings/membershipSetting';
            } else if (img.hasClass('to-analytics')) {
                window.location.href = '/analytics/index';
            } else if (img.hasClass('to-wechat')) {
                window.location.href = '#settings/restaurant/wechat';
            }
        },

        subscript: function () {
            var self = this, restaurant = POS.getRestaurant();
            self.guideView.$el.find('.survey-form').hide();
            self.guideView.$el.find('.success').removeClass('hidden');
            self.guideView.$el.find('.success .email').addClass('hidden');
            self.guideView.$el.find('.success .phone').addClass('hidden');
            self.guideView.$el.find('.send-success').removeClass('hidden');
            if (restaurant.get('experienceRestaurant')) {
                self.needRefresh = true;
                self.$('.experienceRestaurantHint').hide();
                restaurant.set('experienceRestaurant', false);
            }
        },
        clickBtn: function (params) {
            var self = this, btn = params.btn;
            if (btn.hasClass("to-sales")) {
                self.submitForm(params.email);
            } else if (btn.hasClass("next-time")) {
                self.guideView._close();
                self._toMoreFunctionGuide();
            } else if (btn.hasClass('toOrder')) {
                analytics('send', 'event', 'Guide', 'GuideToOrder', POS.getRestaurant().get('name'));
            } else if (btn.hasClass('subscribe-done')) {
                analytics('send', 'event', 'Guide', 'GuideToSales', POS.getRestaurant().get('name'));
                mixpanel.track('完成流程');
                self.tableView._completeSurvey(btn);
            } else if (btn.hasClass('register-later')) {
                self.guideView.model.clear({silent: true});
                self.guideView.model.set({
                    guideImage: "<img src= " + i18n.msg('pos.survey.step1.image') + ">"
                });
                self.guideView.$el.find('.guideImage').addClass('img-cursor-pointer');
                self.$('.experienceRestaurantHint').removeClass('hidden');
            } else if (btn.hasClass('register')) {
                self._registerExperience();
                self.$('.experienceRestaurantHint').removeClass('hidden');
            }
        },
        changeStateTryCatch: function (args) {
            var stateId = _.isArray(args) ? args[0] : args,
                tables = this.model.get("tableCollection"),
                self = this;

            this.tableView.stopListening();
            if (!DB.getStatus().online && stateId.indexOf('settings') >= 0) {
                alert(i18n.msg("pos.offline.settings.error"));
                return;
            }

            $('.state').addClass('hidden');
            $(stateId).removeClass('hidden');
            this.$('.mainMenu > a > span').removeClass('active');

            var allAnchor = this.$(".mainMenu > a");
            allAnchor.each(function () {
                var self = $(this);
                self.attr("href", self.attr("data-href"));
            });

            if (this.overviewKeyPageChange) {
                this.$el.off('keydown', this.overviewKeyPageChange);
            }

            if (this.needRefresh && stateId.indexOf('settings') < 0) {
                this.$('#needRefresh').removeClass('hidden');
            }

            if (stateId.indexOf('table') >= 0) {
                var tableId = args[1];
                var enterEmptyTable = args[2]; // whether enter table page if it is an empty table

                var _table = tables.get(tableId);

                if (_table.isEmpty() && !_table.isWebTable() && !enterEmptyTable) {
                    Backbone.history.navigate("order/" + tableId, {trigger: true});
                    return false;

                } else {
                    this.tableView.model = _table;
                    this.tableView.render();
                    var restaurant = POS.getRestaurant();
                    if (restaurant.get('autoClearTable') && _table.getStatus() == "Paid" && !_table.isWebTable()) {
                        var referred = _table.close();
                        referred.done(function () {
                            Backbone.history.navigate('overview', {trigger: true});
                        });
                        referred.fail(function () {
                        });
                    }
                }

            } else if (stateId.indexOf('order') >= 0) {
                var tableId = args[1];
                var _table = this.model.get("tableCollection").get(tableId);
                if (_table && _table.isWebTable()) {
                    // if this table is for web orders, jump to table page
                    Backbone.history.navigate("table/" + tableId, {trigger: true});
                    return false;
                }
                if (_table) {
                    this.orderView.model.set("currentTable", _table);
                }
                this.orderView.render();
                this.$('.mainMenu span.order').addClass('active');
            } else if (stateId.indexOf('settings') >= 0) {
                this.settingsView.render(args[1]);
                this.$('.mainMenu span.settings').addClass('active');

            } else if (stateId.indexOf('cashier') >= 0) {
                this.cashierView.render(args.length > 1 ? args[1] : {});
                this.$('.mainMenu span.cashier').addClass('active');

            } else if (stateId.indexOf('overview') >= 0) {
                POS.get("tableCollection").each(function (it) {
                    it.refreshStatus();
                    it.getActiveBillCollection().each(function (bill) {
                        bill.calculateAmount();
                        bill.calculateRefund();
                    });
                });

                if (tables.length == 1) {
                    Backbone.history.navigate("table/" + tables.first().id, {trigger: true});
                    return;
                }

                this.overviewView.render();
                this.$('.mainMenu span.overview').addClass('active');
                this.overviewKeyPageChange = function (evt) {

                    //right arrow
                    if (evt.keyCode == 39) {
                        self.overviewView.pageDown();
                    }

                    //left arrow
                    if (evt.keyCode == 37) {
                        self.overviewView.pageUp();
                    }
                };

                this.$el.on('keydown', this.overviewKeyPageChange);

            } else if (stateId.indexOf('sales') >= 0) {
                this.salesView.render("sales");
                this.$('.mainMenu span.sales').addClass('active');
            } else if (stateId.indexOf('notifications')) {
                this.notificationCenterView.render();
            }

            var activeAnchor = this.$(".mainMenu span.active").parent("a");
            activeAnchor.attr("href", "javascript:void(0);");
        },
        changeState: function (args) {
            try {
                this.changeStateTryCatch(args);
            } catch (error) {
                console.error('change state error', error);
            }
        },

        highlightState: function (evt) {
            if ($(evt.target).hasClass('settings') && !DB.getStatus().online) {
                return;
            }

            $('.mainMenu span').removeClass('active');
            $(evt.currentTarget).addClass('active');
        },
        syncStateChanged: function () {
            this.$el.toggleClass('syncing', POS.getSyncStatus().get('syncing'));
        },
        mainMenuLinkClicked: function (e) {
            window.location.href = $(e.currentTarget).attr("href");
            return false;
        },
        _charge: function () {
            var self = this, offlineMsg = i18n.msg("pos.membership.offline");
            if (!DB.getStatusModel().get("online")) {
                new ModalView({
                    hideFooter: true,
                    body: "<h1 class='large' style='color: white; text-align: center;'>" + offlineMsg + "</h1>"
                }).render();
                return;
            }
            self._showMembershipChargeModal();
            return false;
        },
        _showMembershipChargeModal: function () {
            var self = this, chargeEl = $(Membership_chargeView());
            var model = new Backbone.Model();
            self.membershipChargeView = new MembershipChargeView({
                el: chargeEl
            });
            var modalView = new ModalView({body: chargeEl, hideFooter: true}).render();
            this.listenToOnce(modalView, "closed", function () {
                console.log("close thirdPartyBillView");
                modalView.close();
            });
        },
        reload: function () {
            window.location.reload();
            return false;
        },
        purchaseLicense: function () {
            this.purchaseLicenseView.show();
        },
        dropdownMenuLinkClicked: function (e) {
            window.location.href = $(e.currentTarget).attr("href");
            $(".mainMenu").click();
        },
        initTooieStatusView: function () {
            var self = this;
            TooieStatusService.initialize();
            self.tooieStatusView = new TooieStatusView({model: TooieStatusService.statusModel()});
            self.tooieStatusView.render();
            TooieStatusService.statusModel().on("change", function (model) {
                console.log("listened status model =", model);
                self.tooieStatusView.render();
            });
        },
        initNotificationView: function () {
            var self = this;
            NotificationService.initialize();
            this.notificationView = new NotificationView({collection: NotificationService.getNotifications()});
            NotificationService.getNotifications().on("add", function (notification) {
                self.notificationView.receiveNotice(notification);
            });
            this.listenTo(this.notificationView, "close", function () {
                this.notificationView._close();
            });
        },
        initPurchaseLicense: function () {
            var self = this;
            self.purchaseLicenseView = new PurchaseLicenseView({model: PurchaseLicenseService.getStatus()});
        },
        _pollRecordToServer: function () {
            let self = this;
            let fetchArray = DB.getPrintRecordQueue();
            if (fetchArray.length > 0) {
                let data = fetchArray.shift();
                PrintService._recordBillPrintCount(data.get("bill"), data.get("printType"));
                _.delay(function () {
                    self._pollRecordToServer()
                }, 1000);
            }
        },
        initPrintRecord: function () {
            let self = this;
            setInterval(function () {
                try {
                    self._pollRecordToServer();
                } catch (e) {
                    console.error("fetch record error")
                }
            }, 10 * 1000);
        },
        _connectToChromePlugins: function () {
            var self = this;
            var printStatusEl = self.$("#print-status");
            PrintService.getPrinterStatus().on("change", function () {
                var status = PrintService.getPrinterStatus();
                if(status.get("offline")){
                    console.log("status === offline");
                    printStatusEl.find(".printer-status-icon").addClass('hidden');
                    printStatusEl.find(".printer-close").removeClass("hidden");
                    printStatusEl.attr("title", "请检查网络,当前为离线状态,请在网络恢复后补打订单");
                    printStatusEl.addClass("error");
                    printStatusEl.tooltip('show');
                }else{
                    console.log("status === online");
                    if (status.get('pluginConnected')) {
                        if (status.get('printerDisconnected')) {
                            printStatusEl.find(".printer-status-icon").addClass('hidden');
                            printStatusEl.find(".printer-error").removeClass("hidden");
                            printStatusEl.attr("title", i18n.msg('pos.print.status.printerDisconnected'));
                            printStatusEl.addClass("error");
                            printStatusEl.tooltip('show');
                        } else {
                            printStatusEl.find(".printer-status-icon").addClass('hidden');
                            printStatusEl.find(".printer-open").removeClass("hidden");
                            printStatusEl.removeClass("error");
                            printStatusEl.attr("title", "");
                            printStatusEl.tooltip('hide');
                        }
                    } else {
                        printStatusEl.find(".printer-status-icon").addClass('hidden');
                        printStatusEl.find(".printer-close").removeClass("hidden");
                        // printStatusEl.attr("title", "请检查网络,当前为离线状态,  请在网络恢复后补打订单");
                        // printStatusEl.attr("title", i18n.msg('pos.print.status.pluginDisconnected'));
                        printStatusEl.addClass("error");
                        printStatusEl.tooltip('show');
                    }
                }

                const queueCount = status.get("queueCount");
                if (POS.getUseCloudPrint()) {
                    printStatusEl.find(".counter").text(queueCount === 0 ? '0' : queueCount);
                } else {
                    printStatusEl.find(".counter").text("");
                }
            });
            PrintService.initialize();
            PrintService.getPrinterStatus().set({queueCount: POS.get("printQueueCount")});
            PrintService.getPrinterStatus().trigger('change');
            self.printerStatusView = new PrinterStatusView({model: PrintService.getPrinterStatus()});
        }

    });
};

let exportValue = main();
export default exportValue;


// WEBPACK FOOTER //
// ./src/PosView.js